export default "__VITE_ASSET__BDtmhM$x__"